module.exports = __webpack_public_path__ + "static/img/modal-error.efc25c52.png";